import React, { Component } from "react";
import Helmet from "react-helmet";
import Header from "../components/Header/Header";
import SocialLinks from "../components/SocialLinks/SocialLinks";
import SEO from "../components/SEO/SEO";
import TechnologiesWeb from "../components/Page/TechnologiesWeb";
import HeaderPage from "../components/Header/HeaderPage";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer/Footer";
import picture from "./img/technologies.jpg";
import config from "../../data/SiteConfig";
import "./page.scss";

export default class TechnologieWebApp extends Component {
  render() {
    // SEO PURPOSES
    const { slug } = this.props.pathContext;


    const postNode = {
        "frontmatter": {
            "title": "Les technologies Web à votre service",
            "description":  "Integral Service conçoit et réalise des solutions Web sur-mesure. Nous adaptons les technologies utilisées à chaque projet afin de répondre au contraintes.",
            "cover": picture
        }
    };

    let title = "Technologies Web";
    let description = "Des technologies réfléchies pour votre projet";
    let goto = "En découvrir plus";

    return (
      <div className="webapp-container page-details">
          <Header/>
          <Menu />
          <Helmet 
          title={`Technologies Web | ${config.siteTitle}`}
          description = {`A chaque projet nous analysons vos besoins afin de déterminer les technologies nécessaires au bon déroulement de celui-ci. `}
          />
          <SEO postPath={slug} postNode={postNode} postSEO />
          <HeaderPage title={title} description={description} picture={picture} />
          <TechnologiesWeb />
          <SocialLinks postPath={slug} postNode={postNode} />
          <Footer />
      </div>
    );
  }
}
;


// WEBPACK FOOTER //
// ./src/pages/technologies-web.jsx